module.exports = __webpack_public_path__ + "static/media/impressora.4eaecb9c.svg";